import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import { blue, orange, red } from '@mui/material/colors';
import Dialog from '@mui/material/Dialog';
import { t } from 'i18next';
import { Set } from 'immutable';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { AutoSizer, Column, SortDirection, Table } from 'react-virtualized';

import { authGroupSelector } from '@sophocles/entities/AuthGroup';
import { roleDisplayNameSwitch } from '@sophocles/utils/userPermissionUtils';

class AuthGroupSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortBy: 'id',
      sortDirection: SortDirection.ASC,
      scrollToIndex: undefined,
      showTable: false,
      selected: Set([]),
    };
  }

  componentDidMount() {
    const { selected } = this.props;
    this.setState({ selected: selected });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.selected, this.props.selected)) {
      this.setState({ selected: nextProps.selected });
    }
  }

  showTable = () => this.setState({ showTable: true });

  hideTable = () => this.setState({ showTable: false });

  hideTableAndResetValues = () => this.setState({ showTable: false, selected: this.props.selected });

  saveSelected = () => {
    const { selected } = this.state;
    const { saveValues } = this.props;

    saveValues(selected);
    this.hideTable();
  };

  toggleSelected = val => {
    const { selected } = this.state;

    selected.contains(val)
      ? this.setState({ selected: selected.delete(val) })
      : this.setState({ selected: selected.add(val) });
  };

  _noRowsRenderer = () => (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        fontSize: '28px',
        backgroundColor: 'var(--surface-secondary)',
      }}
    >
      {' '}
      No Data Found{' '}
    </div>
  );

  _rowClassName = ({ key, index, style, isScrolling }) => {
    if (index < 0) {
      return 'rv-table-row-header';
    }
    return index % 2 === 0 ? 'rv-table-row-even' : 'rv-table-row-odd';
  };

  _getDatum = (list, index) => list.get(index % list.size);

  _sort = ({ sortBy, sortDirection }) => this.setState({ sortBy, sortDirection });

  render() {
    const { authGroups, customer } = this.props;
    const { sortBy, sortDirection, scrollToIndex, showTable, selected } = this.state;

    const data = authGroups.map(item => item.set('name', roleDisplayNameSwitch(item.get('id', -1)))).toList();

    const selectedDisplay = data
      .filter(group => this.props.selected.contains(group.get('id', 0)))
      .sortBy(item => item.get('id', -1));

    let sortedList = data
      .sortBy(item => item.get(sortBy, 'id'))
      .update(list => (sortDirection === SortDirection.DESC ? list.reverse() : list));

    const customerGroups = [7, 8, 9];
    if (customer != 1) {
      sortedList = sortedList.filter(group => _.includes(customerGroups, group.get('id', -1)));
    }

    const actions = [
      <Button key="cancel" variant="outlined" onClick={this.hideTableAndResetValues}>
        {t('actions.cancel', 'Cancel')}
      </Button>,
      <Button key="submit" variant="contained" onClick={this.saveSelected}>
        {t('actions.submit', 'Submit')}
      </Button>,
    ];

    const rowGetter = ({ index }) => this._getDatum(sortedList, index);

    return (
      <div>
        <div>
          User Roles{' '}
          <span style={{ color: blue[700], cursor: 'pointer' }} onClick={this.showTable}>
            (change)
          </span>
        </div>
        <div />
        <div>
          {selectedDisplay.isEmpty() ? (
            <div style={{ color: red[500] }}>{t('users.mustChooseRole', 'Must Choose a Role')} </div>
          ) : (
            <ul>
              {selectedDisplay.map(group => (
                <li
                  key={group.get('id')}
                  style={{
                    color:
                      customer != 1 ? (_.includes(customerGroups, group.get('id', -1)) ? '#333' : red[500]) : '#333',
                  }}
                >
                  {group.get('name', 'none')}
                </li>
              ))}
            </ul>
          )}
          {customer != 1 &&
          !selectedDisplay.filterNot(group => _.includes(customerGroups, group.get('id', -1))).isEmpty() ? (
            <div>
              <span style={{ color: orange[500], fontSize: '14px' }}>
                <i className="fas fa-exclamation-triangle" /> Some roles cannot be assigned to this user, they will be
                cleared when you save changes.
              </span>
            </div>
          ) : null}
        </div>
        <Dialog fullWidth maxWidth="lg" open={showTable} onClose={this.hideTableAndResetValues}>
          <DialogTitle>{t('users.permissionGroups', 'Permission Groups')}</DialogTitle>
          <DialogContent dividers>
            <div className="sg-list-body" style={{ height: '300px' }}>
              <AutoSizer>
                {({ height, width }) => (
                  <Table
                    disableHeader={false}
                    headerHeight={40}
                    height={height}
                    noRowsRenderer={this._noRowsRenderer}
                    overscanRowCount={10}
                    className="rv-table table-striped"
                    headerClassName="rv-table-header"
                    rowClassName={this._rowClassName}
                    rowHeight={50}
                    rowGetter={rowGetter}
                    rowCount={sortedList.size}
                    scrollToIndex={scrollToIndex}
                    sort={this._sort}
                    sortBy={sortBy}
                    sortDirection={sortDirection}
                    width={width}
                  >
                    <Column
                      dataKey="id"
                      label="Select"
                      disableSort={true}
                      width={80}
                      cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => (
                        <div>
                          <Checkbox
                            checked={selected.contains(cellData)}
                            onChange={() => this.toggleSelected(cellData)}
                          />{' '}
                        </div>
                      )}
                      headerRenderer={({ columnData, dataKey, disableSort, label, sortBy, sortDirection }) => label}
                    />
                    <Column dataKey="id" width={50} label="ID" />
                    <Column dataKey="name" width={100} label="Name" flexGrow={1} />
                  </Table>
                )}
              </AutoSizer>
            </div>
          </DialogContent>
          <DialogActions>{actions}</DialogActions>
        </Dialog>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    authGroups: authGroupSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

const AuthGroupSelectionContainer = connect(mapStateToProps, mapDispatchToProps)(AuthGroupSelection);

export default AuthGroupSelectionContainer;
